import { render, staticRenderFns } from "./ModalPhoto.vue?vue&type=template&id=724b791e&scoped=true"
import script from "./ModalPhoto.vue?vue&type=script&lang=js"
export * from "./ModalPhoto.vue?vue&type=script&lang=js"
import style0 from "./ModalPhoto.vue?vue&type=style&index=0&id=724b791e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724b791e",
  null
  
)

export default component.exports